<template>
	 <div class='bread_container' id="bread_container" style="min-width:200px">
	    <span @click="handleLeftMenu" class="bars"> 
		    <i class="fa fa-bars"  :class="{isactive:changeBarDirection}"></i>
		</span>
        <el-breadcrumb class="breadcrumb" separator="/">

			    <el-breadcrumb-item :to="{ path: '/orderList' }">首页</el-breadcrumb-item>
			      <!-- <el-breadcrumb-item >首页</el-breadcrumb-item> -->
            <el-breadcrumb-item 
                v-for='(item,index) in levelList'
                :key='index'>
				<span v-if="item.name!=null">{{item.name}}</span>
			</el-breadcrumb-item>
        </el-breadcrumb>
    </div>
</template>


<script>
import * as mUtils from 'utils/mUtils'
export default {
	  
	data(){
		return {
			  windowWidth: document.documentElement.clientWidth,  //实时屏幕宽度
            windowHeight: document.documentElement.clientHeight,   //实时屏幕高度
          lketg:false,
			companyId:mUtils.getStore('companyId'),
			changeBarDirection:false,
			levelList: null
		}
	},
	created() {
        this.getBreadcrumb()
    },
	methods:{
		handleLeftMenu(){
		  let that=this
		  that.changeBarDirection=!that.changeBarDirection
		    this.$store.dispatch('setLeftCollapse');  // 折叠菜单
			this.$store.dispatch('handleLeftMenu');  // 改变菜单宽度
			this.$store.dispatch('dropName');   // 隐藏单一菜单名称
			this.setSize()
       if(this.lketg){
       that.left='left'
       that.lketg=!that.lketg
       mUtils.setStore('lketg',that.lketg)
       }else{
         that.left='right'
          that.lketg=!that.lketg
           mUtils.setStore('lketg',that.lketg)
       }
    },
    	setSize() {
        let  win_size = {}
        let that=this
       if(this.lketg){

           window.fullHeight = document.documentElement.clientHeight-50;
                window.fullWidth = document.documentElement.clientWidth-141;
                     that.windowHeight = window.fullHeight;  // 高
              that.windowWidth = window.fullWidth; // 宽
    // console.log(document.documentElement.clientHeight, document.documentElement.clientWidth)
          win_size = {
				// width:(this.$store.state.menu.sidebar.opened)? this.$$lib_$(window).width()-180:this.$$lib_$(window).width()-35,
				width:that.windowWidth,
				height:that.windowHeight
			}
       }else{
         
	 win_size = {
				// width:(this.$store.state.menu.sidebar.opened)? this.$$lib_$(window).width()-180:this.$$lib_$(window).width()-35,
				width:(this.$store.state.menu.sidebar.opened)? document.body.clientWidth-15:document.body.clientWidth-15,
				height:document.body.clientHeight-50
			}
       }
			//将content部分的宽高，存入store中，
			this.$store.dispatch('set_win_content',win_size);
		},
		getBreadcrumb() {
			// 前三个，只拿数组[0]的值；
			let matched = this.$route.matched.filter(item => item.name);
			const first = matched[0];
			if(first && first.path == '/index'){
				matched = {};
			}else if(first && (first.path == '/userList' || first.path == '/infoList')){
				matched = [matched[0]];
			}
			this.levelList = matched;
      }
	},
	watch: {
      $route() {
           this.getBreadcrumb();
      }
    }
}



</script>

<style lang="less">
	.bread_container{
		background-color: #EFF2F7;
		margin-bottom: 5px;
		width: 100%;
		padding-left:16px;
		.bars{
			float: left;
            margin: 4px 10px;
			cursor: pointer;
			.isactive{
				-webkit-transform: rotate(90deg);
				transform: rotate(90deg);
				transition: .38s;
				-webkit-transform-origin: 50% 50%;
				transform-origin: 50% 50%;
			}
		}
		.breadcrumb{
			height: 30px;
			line-height: 30px;
			.breadbutton{
				float:left;
				margin:4px 5px 0 0;
				
			}
		}
	}
</style>





// WEBPACK FOOTER //
// bread.vue?4681f7a7